import { useMutation } from '@tanstack/react-query';

import { useAuthSession } from '@/features/auth/useAuthSession';
import { usePlatform } from '@/platform/usePlatform';
import { forgetSession } from '@/services/auth';
import { deleteAccount } from '@/services/account';

/**
 * Удаление аккаунта.
 *
 * После успеха — не точечная инвалидация кэша (credits, history, favorites
 * и всё остальное разом стали данными несуществующего пользователя), а
 * полная перезагрузка: AuthProvider заведёт сессию тем же путём, что при
 * первом открытии приложения — анонимную в вебе и новую платформенную в
 * Mini App, где прежнего владельца площадки уже не существует (ADR-041).
 */
export function useDeleteAccount() {
  const { session } = useAuthSession();
  const platform = usePlatform();

  return useMutation({
    mutationFn: async () => {
      if (!session) {
        throw new Error('Нет активной сессии.');
      }

      await deleteAccount(session.access_token);
      await forgetSession();
    },
    onSuccess: () => {
      platform.restart('/');
    },
  });
}
